module.exports = __webpack_public_path__ + "static/kure0-ca37aa08be154ac34748cfb6b3b43c05.png";